import Cookies from 'js-cookie';
import { ILoginPrarm, ITokenChangePrarm, thirdLogin, tokenChange } from '@src/apis/auth';
import { storage } from '@src/shared/storage';

// 处理 code 参数和获取 Token
export const handleCodeAndGetToken = async () => {
    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get('code') as string
    const params: ILoginPrarm = {
        org_key: __ORG_KEY__,
        third_auth_code: code,
        third_auth_type: 'fuTianAuth',
        redirect_url: window.location.origin + window.location.pathname
    }
    // const tempParams: Pick<ITempLoginPrarm, 'org_key'> = {
    //     org_key: __ORG_KEY__,
    // }
    try {
        if (code) {
            const resp = await thirdLogin(params)
            const token = resp.token;
            Cookies.set('token', token, { expires: 7, secure: true, sameSite: 'None' });
            storage.set('user_id', resp.user_id)
            storage.set('user', resp)
            storage.set('st_token', '')
            // 清除 URL 中的 code 参数
            const queryParams = new URLSearchParams(window.location.search);
            queryParams.delete('code');
            const newUrl = window.location.pathname + (queryParams.toString() ? `?${queryParams.toString()}` : '');
            window.history.replaceState({}, '', newUrl);
            window.location.href = window.location.origin + window.location.pathname
        }
        if (storage.get('st_token')) {
            const tokenParams: ITokenChangePrarm = {
                org_key: __ORG_KEY__,
                token: storage.get('st_token'),
                third_auth_type: 'fuTianAuth',
            }
            const resp = await tokenChange(tokenParams)
            const token = resp.token;
            Cookies.set('token', token, { expires: 7, secure: true, sameSite: 'None' });
            storage.set('user_id', resp.user_id)
            storage.set('user', resp)
        }

    } catch (error) {
        console.error('获取 Token 失败:', error);
    }
};
